import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { fetchManualStkItem, updateGarmentMStock } from '../../../Store/PHPSlice/Stock/StockApis';
import { selectManualStkItem } from '../../Selectors/StitchSelector/StitchingSelectors';
import { fetchClothData } from '../../../Store/PHPSlice/Cloth';
import { selectCloths } from '../../Selectors/Master/ItemSelectors';
import DropdownWithBtn from '../../FieldsComponents/DropdownWithBtn';


const ManualStkEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        new_mcloth: '',
        new_m1cloth: '',
        new_m2cloth: '',
        new_m3cloth: '',
        userId: userdata?.ID
    });

    const [stkdata, setStkdata] = useState([]);

    const dispatch = useDispatch();
    const manualstk = useSelector(selectManualStkItem);
    const clothdata = useSelector(selectCloths);
    const [openDropdowns, setOpenDropdowns] = useState({});

    const [loading, setLoading] = useState(false);

    const actionMap = {
        new_mcloth: fetchClothData,
        new_m1cloth: fetchClothData,
        new_m2cloth: fetchClothData,
        new_m3cloth: fetchClothData
    }
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();

    useEffect(() => {
        dispatch(fetchManualStkItem(Id));

    }, [Id, dispatch]);

    useEffect(() => {
        dispatch(fetchClothData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (manualstk?.data) {
            const item = manualstk?.data;
            const total = manualstk?.info?.reduce((acc, sum) => acc + parseFloat(sum.qty), 0);
            setFormData(prev => ({
                ...prev,
                date: item.date,
                itemNm: item.itemNm,
                new_mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                m1clothNm: item.m1clothNm,
                m2clothNm: item.m2clothNm,
                m3clothNm: item.m3clothNm,
                rack: item.rack,
                locNm: item.locNm,
                bailno: item.bailno,
                totqty: total
            }));
        }

        setStkdata(manualstk?.info);
    }, [manualstk]);

    // console.log(formData);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleChange = (index, e) => {
        const { name, value } = e.target;

        if (name === "newqty" && !/^\d*$/.test(value)) return; // Reject anything not digits

        setStkdata(prevData => {
            const updated = [...prevData];
            updated[index] = {
                ...updated[index],
                [name]: value   // dynamically update (newqty, rate, balqty…)
            };
            return updated;
        });
    };


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };


    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        // switch (dropdownType) {
        //     case 'depart':

        //         break;

        //     default:
        //         break;
        // }
    };


    const handleItemNew = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };



    const dropdownlistfirst = [
        {
            label: 'Main Cloth',
            id: 'new_mcloth',
            options: clothdata?.data || [],
            value: formData.new_mcloth,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'new_mcloth', value: newValue ? newValue.ID : '' } }, 'new_mcloth'),
            getOptionLabel: (option) => option.clothName || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('new_mcloth'),
            handleDropdownClose: () => handleDropdownClose('new_mcloth'),
        },
        {
            label: 'M1 Cloth',
            id: 'new_m1cloth',
            options: clothdata?.data || [],
            value: formData.new_m1cloth,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'new_m1cloth', value: newValue ? newValue.ID : '' } }, 'new_m1cloth'),
            getOptionLabel: (option) => option.clothName || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('new_m1cloth'),
            handleDropdownClose: () => handleDropdownClose('new_m1cloth'),
        },

        {
            label: 'M2 Cloth',
            id: 'new_m2cloth',
            options: clothdata?.data || [],
            value: formData.new_m2cloth,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'new_m2cloth', value: newValue ? newValue.ID : '' } }, 'new_m2cloth'),
            getOptionLabel: (option) => option.clothName || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('new_m2cloth'),
            handleDropdownClose: () => handleDropdownClose('new_m2cloth'),
        },
        {
            label: 'M3 Cloth',
            id: 'new_m3cloth',
            options: clothdata?.data || [],
            value: formData.new_m3cloth,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'new_m3cloth', value: newValue ? newValue.ID : '' } }, 'new_m3cloth'),
            getOptionLabel: (option) => option.clothName || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('new_m3cloth'),
            handleDropdownClose: () => handleDropdownClose('new_m3cloth'),
        },
    ];

    function postobj(Id, formData, stkdata) {

        const data = {
            mstkId: Id,
            new_mcloth: formData.new_mcloth,
            new_m1cloth: formData.new_m1cloth || '0',
            new_m2cloth: formData.new_m2cloth || '0',
            new_m3cloth: formData.new_m3cloth || '0',
            stkdata: stkdata || [],
            userId: formData.userId,
        };
        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const postData = postobj(Id, formData, stkdata);
            // console.log(postData);

            const result = await dispatch(updateGarmentMStock(postData)).unwrap();
            console.log('POST request successful!', result);
            alert("Stock Updated Successfully");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    // console.log(formData)
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Manual Stock Edit</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.date}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Item</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.itemNm}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.mclothNm}</td>
                                    <td style={{ width: '200px' }}>M1 Cloth</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.m1clothNm}</td>
                                </tr>


                                <tr>
                                    <td style={{ width: '200px' }}>M2 Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.m2clothNm}</td>
                                    <td style={{ width: '200px' }}>M3 Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.m3clothNm}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Rack</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.rack}</td>
                                    <td style={{ width: '200px' }}>Location</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.locNm}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Total Qty.</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.totqty}</td>
                                    <td style={{ width: '200px' }}>Bail No.</td>

                                    <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.bailno}</td>
                                </tr>

                            </tbody>
                        </table>


                        {
                            dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                <DropdownWithBtn
                                    key={drop.label}
                                    label={drop.label}
                                    id={drop.id}
                                    options={drop.options}
                                    value={drop.value}
                                    onChange={drop.onChange}
                                    isDesktop={isDesktop}
                                    getOptionLabel={drop.getOptionLabel}
                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                    valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                    handleAddNew={drop.handleAddNew}
                                    btnlabel={drop.btnlabel}
                                    handleDropdownOpen={drop.handleDropdownOpen}
                                    handleDropdownClose={drop.handleDropdownClose}
                                />
                            ))
                        }


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Color</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Shade No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Prev. Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>New Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(stkdata) && stkdata?.length > 0 ? (
                                        stkdata?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                    <input
                                                        type="text"
                                                        name="color"
                                                        value={item.color || ""}
                                                        style={{ width: '100px', padding: '2px', outline: 'none' }}
                                                        onChange={(e) => handleChange(index, e)}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                    <input
                                                        type="text"
                                                        name="shadeNo"
                                                        value={item.shadeNo || ""}
                                                        style={{ width: '100px', padding: '2px', outline: 'none' }}
                                                        onChange={(e) => handleChange(index, e)}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rate}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.balqty}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                    <input
                                                        type="text"
                                                        name="newqty"
                                                        value={item.newqty || "0"}
                                                        style={{ width: '100px', padding: '2px', outline: 'none' }}
                                                        onChange={(e) => handleChange(index, e)}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))

                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <Grid item xs={12} textAlign="center">
                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                            {
                                loading === true ?
                                    <><CircularProgress size="20px" /> wait...</> :
                                    "Submit"
                            }
                        </Button>
                    </Grid>

                </Paper>
            </Grid>
        </>
    );
};

export default ManualStkEdit;
